export default __webpack_public_path__ + "static/swvl-banner-2b278fc471b1009f7eecfee9db739354.webp";